import { resolveEntityPath } from "./resolveEntityPath";
import { refreshOpenDetailTab } from "./tabNavigation";

export function refreshParentOrderForOrderService({
  tabActions,
  userRole,
  currentPathname,
  orderId,
}) {
  if (!tabActions?.enabled || !orderId) return false;

  const orderPath = resolveEntityPath("order", userRole, currentPathname);
  if (!orderPath) return false;

  const id = String(orderId);
  return refreshOpenDetailTab(tabActions, orderPath, id);
}
